/**
 * Uploads an image ahead of its first draw, in small slices between frames (`WebGLDevice.prepare`), for code with no
 * device at hand (terrain.ts: the ground chunks as the workers send them). Set by the device (webgl.ts); null until
 * one is made. No imports: terrain.ts also runs in the ground workers.
 */
export const gpuPrepare: {
  fn: ((image: CanvasImageSource & { width: number }) => void) | null;
  /** Uploads a texture source of its own now (render/turned/scenery.ts: a turned building's picture, on the frame its piece is made, under the art budget). */
  source: ((source: unknown) => void) | null;
} = { fn: null, source: null };
